import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-bottom: 4px solid #000fff;
  margin-top: 12px;
  width: 95%;

  @media (max-width: 770px) {
    width: 100%;
    padding: 12px;
    margin-top: 0;
  }
`;

export const ChartTitle = styled.h2`
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin: 0 0 10px 0;

  @media (max-width: 770px) {
    font-size: 14px;
    margin-bottom: 8px;
  }
`;

export const ChartWrapper = styled.div`
  display: flex;
  align-items: stretch;
  gap: 12px;

  @media (max-width: 770px) {
    gap: 6px;
  }
`;

export const YAxisLabels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 0 32px 0;
  font-size: 12px;
  color: #808080;
  font-weight: 500;
  min-width: 44px;
  box-sizing: border-box;

  @media (max-width: 770px) {
    min-width: 32px;
    padding: 18px 0 28px 0;
    font-size: 11px;
  }
`;

export const ChartContainer = styled.div`
  flex: 1;
  min-width: 0;
  height: 260px;

  @media (max-width: 770px) {
    height: 240px;
    min-height: 240px;
    overflow: visible;
  }

  .recharts-wrapper {
    @media (max-width: 770px) {
      overflow: visible;
    }
  }
`;

export const ChartDateText = styled.div`
  font-size: 12px;
  color: #333333;
  margin-top: 12px;
  margin-bottom: 25px;
  text-align: right;
`;

export const TooltipWrapper = styled.div`
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 10px 14px;
`;

export const TooltipLabel = styled.div`
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
`;

export const TooltipValue = styled.div`
  color: #000fff;
  font-weight: 600;
`;
